import { render, staticRenderFns } from "./CalendarComponent.vue?vue&type=template&id=937dffb4"
import script from "./CalendarComponent.vue?vue&type=script&lang=js"
export * from "./CalendarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports